<template>
    <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
        v-show="showSpinner"
        class="spinnerRegReport"
      ></v-progress-circular>
</template>

<script>
export default {
	name: 'ProgressCircular',
	props: ['showSpinner'],
	data() {
		return {
		}
	},
}
</script>

<style>
.spinnerRegReport{
    margin: 35px;
}

</style>
